import axios from 'axios'
import Vue from 'vue'

export default {
  /**
   * Start the auto run process for a specific race
   * @param {number|string} raceId - The ID of the race to start auto run for
   * @returns {Promise} - Promise that resolves when the auto run process is initiated
   */
  startAutoRun(raceId) {
    return axios.post(`${Vue.prototype.$expressApi}api/races/${raceId}/auto-run`, {
      action: 'start'
    })
  },

  /**
   * Get upcoming auto-pilot runs
   * @param {number} durationDays - Number of days to look ahead (default: 5)
   * @returns {Promise} - Promise that resolves with upcoming auto-pilot runs
   */
  getUpcomingAutoPilotRuns(durationDays = 5) {
    return axios.get(`${Vue.prototype.$expressApi}api/auto-run/upcoming?days=${durationDays}`)
  },

  /**
   * Get the status of all scheduled auto run tasks
   * @returns {Promise} - Promise that resolves with scheduled tasks status
   */
  getScheduledTasksStatus() {
    return axios.get(`${Vue.prototype.$expressApi}api/auto-run/scheduled-tasks`)
  },

  /**
   * Get the status of all active auto runs
   * @returns {Promise} - Promise that resolves with active runs status
   */
  getActiveRunsStatus() {
    return axios.get(`${Vue.prototype.$expressApi}api/auto-run/active-runs`)
  }
}



// WEBPACK FOOTER //
// ./src/services/autoRun.js